import { createAction, props } from '@ngrx/store';

import { Candidate, Job } from '@shared/models';
import { AtsMessage } from '@shared/models/AtsMessage';
import { DirectApplicantsPerPhaseNumber } from '@shared/models/direct-applicants-per-phase-number';
import { Pagination } from '@shared/pagination';

export const jobCandidatesClear = createAction('[Job Page] Matched Candidates Clear');

export const collectionCandidatesClear = createAction('[Job Page] Collection Candidates Clear');

export const jobCandidatesLoad = createAction(
  '[Job Page] Matched Candidates Load',
  props<{ params: { offset?: number; sort?: string } }>(),
);

export const loadJobMatchesCounts = createAction('[Job Page] Load Job Matches Counts');

export const loadJobMatchesCountsSuccess = createAction(
  '[Job Page] Load Job Matches Counts Success',
  props<{ payload: any }>(),
);

export const loadJobMatchesCountsFail = createAction(
  '[Job Page] Load Job Matches Counts Fail',
  props<{ error: any }>(),
);

export const jobCandidatesLoadSuccess = createAction(
  '[Job Page] Matched Candidates Load Success',
  props<{ payload: Pagination<Candidate>; category?: string; directCandidatesCount?: number }>(),
);

export const jobCandidatesLoadFail = createAction(
  '[Job Page] Matched Candidates Load Fail',
  props<{ error: any }>(),
);

export const jobMatchesNumberForJobSuccess = createAction(
  '[Job Page] Matches Candidates Numbers Load Success',
  props<{ matchesNumbers: any }>(),
);

export const loadDirectCandidatesNumberPerPhase = createAction(
  '[Job Page] Load Direct Candidates Number Per Phase',
  props<{ jobId?: number }>(),
);

export const loadDirectCandidatesNumberPerPhaseSuccess = createAction(
  '[Job Page] Load Direct Candidates Number Per Phase success',
  props<{ directApplicantsPerPhaseNumbers: DirectApplicantsPerPhaseNumber[] }>(),
);

export const loadDirectCandidatesNumberPerPhaseFail = createAction(
  '[Job Page] Load Direct Candidates Number Per Phase fail',
  props<{ error: any }>(),
);

export const jobRefresh = createAction(
  '[Job Page] Refresh Job from ATS',
  props<{ atsMessage: AtsMessage }>(),
);

export const jobRefreshSuccess = createAction(
  '[Job Page] Refresh Job from ATS SUCCESS',
  props<{ job: Job }>(),
);

export const shortlistedCandidatesWithAssociationsLoadSuccess = createAction(
  '[Job Page] Shortlisted Candidates With Associations Load Success',
);
